import "./index.css";
import React, { useState, useEffect, Fragment, useRef } from "react";
import { Document, Page } from "react-pdf";

/**
 * TODO: This modal will replace the bootstrap-built PDFViewerModal
 * in /src/components/PDFViewer as we mainly use it on top of a previously
 * opened bootstrap modal. However, as described in their documentation,
 * this should be avoided as it may cause unexpected behaviour.
 */
export default function PDFViewerModal({ pdfUrl, setSelectedPDF, hex, white }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToNextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const goToPrevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const onClose = () => {
    setSelectedPDF(null);
  };

  const isBtnDisabled = (isNext = true) => {
    if (isNext) return pageNumber >= numPages;
    else return pageNumber <= 1;
  };

  return (
    <div className="pdf-viewer">
      <div className="modal-header">
        <h5 className="modal-title">Your uploaded PDF document</h5>
        <button
          type="button"
          className="close pdf-viewer__close-btn"
          aria-label="Close"
          onClick={onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body pb-1 pdf-viewer__modal-body">
        <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
          <Fragment key={pageNumber}>
            <Page key={`page_${pageNumber + 1}`} pageNumber={pageNumber} />
            <div className="pdf-viewer__container">
              <button
                onClick={goToPrevPage}
                disabled={isBtnDisabled(false)}
                className={`btn btn-white btn-sm btn-brand-hex ${
                  isBtnDisabled(false) ? "pdf-viewer__btn--disabled" : ""
                }`}
                style={{
                  "--hover-text-color": white ? "white" : "black",
                  "--hover-color": hex,
                  backgroundColor: "white",
                  color: "black",
                }}
              >
                Prev
              </button>
              <p>{`${pageNumber} of ${numPages}`}</p>
              <button
                onClick={goToNextPage}
                disabled={isBtnDisabled()}
                className={`btn btn-white btn-sm btn-brand-hex ${
                  isBtnDisabled() ? "pdf-viewer__btn--disabled" : ""
                }`}
                style={{
                  "--hover-text-color": white ? "white" : "black",
                  "--hover-color": hex,
                  backgroundColor: "white",
                  color: "black",
                }}
              >
                Next
              </button>
            </div>
          </Fragment>
        </Document>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/UploadPanel/components/PDFViewerModal/index.js